import { useEffect } from "react";
import { usePostGooders } from "../hooks/usePost";
import { useNotify } from "../hooks/NotifyProvider";
import {
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  CircularProgress,
} from "@mui/material";

export const GoodDetail = ({ postId }) => {
  const { data: goods = [], isLoading, isError } = usePostGooders(postId);
  const { notify } = useNotify();

  useEffect(() => {
    if (isError) notify("Failed to loading.", "error");
  }, [isError, notify]);

  const handleClick = (selectedHandle) => {
    const newUrl = `${window.location.origin}/${selectedHandle}`;
    window.open(newUrl, "_blank");
  };

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center ">
          <CircularProgress />
        </div>
      ) : (
        <>
          {goods.length !== 0 ? (
            <List sx={{ width: "100%" }}>
              {goods.map((good) => (
                <ListItem
                  key={good.goodId}
                  onClick={() => {
                    handleClick(good.user.handle && good.user.handle);
                  }}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      bgcolor: "action.hover",
                      textDecoration: "none",
                      borderRadius: 2,
                      "& *": {
                        textDecoration: "none",
                      },
                    },
                  }}
                >
                  <ListItemAvatar>
                    <Avatar src={good.user.picture && good.user.picture} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={good.user.name}
                    secondary={`@${good.user.handle}`}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <div className="font-soft flex justify-center">Not yet</div>
          )}
        </>
      )}
    </div>
  );
};
